import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-signup-confirmation',
  templateUrl: './signup-confirmation.component.html',
  styleUrls: ['./signup-confirmation.component.scss']
})
export class SignupConfirmationComponent implements OnInit {

  resend_mail;

  constructor(private authservice: AuthService,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.resend_mail = localStorage.getItem('resend_mail')
  }

  resendMail() {
    console.log("clicked")
    this.authservice.resendMail(this.resend_mail).subscribe(
      res => {
        this.toastr.success('An email to your account ' + this.resend_mail + ' has been sent again', 'Success');
        localStorage.clear()
      },
      err => {
        this.toastr.error('There is err sending email to your account', 'Error');
        localStorage.clear()
      }
    )
  }

  click(event){
    console.log(event)
    
  }

}
